export interface CurrentUserSnapshot {
  id?: string;
  role?: string | null;
  is_organization_owner?: boolean;
  is_super_admin?: boolean;
  [k: string]: unknown;
}

let snapshot: CurrentUserSnapshot | null = null;

export function setCurrentUser(user: CurrentUserSnapshot | null): void {
  snapshot = user;
}

export function getCurrentUser(): CurrentUserSnapshot | null {
  return snapshot;
}

export type Audience = "owner" | "super_admin" | "admin" | "agent" | "anonymous";

export function audienceOf(user?: CurrentUserSnapshot | null): Audience {
  if (!user) return "anonymous";
  if (user.is_super_admin) return "super_admin";
  if (user.is_organization_owner) return "owner";
  const role = (user.role || "").toString().trim().toUpperCase();
  if (role === "ADMIN") return "admin";
  return "agent";
}

export function canManage(user?: CurrentUserSnapshot | null): boolean {
  const a = audienceOf(user);
  return a === "owner" || a === "super_admin" || a === "admin";
}
